/* eslint-disable */
import { FormulsNaming, NamesTranslation } from '@/enums/configurator'
import Api from '@/repository/index'
import { Message } from 'element-ui'
const state = {
  data: [],
  formula_check: {
    detailsIncome: 0,
    earnAmount: 0,
    commonTenantsIncome: 0,
    companyProfit: 0,
    giveOutAmount: 0
  },
  isLoading: true
}

const mutations = {
  SET: (state, data) => {
    state.data = data
  },
  UPDATE_FORMULS: (state, datas) => {
    for (const key in datas.response) {
      if (datas.data.hasOwnProperty(key) && datas.data[key] !== undefined && datas.data[key] !== null) {
        state.data[key] = datas.data[key]
      }
    }
    // state.data = [
    //   new_formula,
    //   ...state.data.filter((v, i) => i !== getIndexFormulaByName)
    // ]
  },
  SET_FORMULA_CHECK_RETURN: (state, value) => {
    state.formula_check = value
  },
  START_LOADING: (state) => {
    state.isLoading = true
  },
  STOP_LOADING: (state) => {
    state.isLoading = false
  }
}
const getters = {
  formulsCheckToNumberFormat: (state) => Object.keys(state.formula_check).reduce((acc, value) => {
    acc = { ...acc, [value]: new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'RUB' }).format(state.formula_check[value]) }
    return acc
  }, {}),
  getFormulsTranslete: (state) => {
    const normalFormatFourmuls = Object.keys(state.data).map((x, y) => {
      return {
        formula_value: state.data[x],
        formula_name: x
      }
    })

    return normalFormatFourmuls.reduce((acc, value) => {
      const formula_translete = FormulsNaming[value.formula_name] || 'Неизвестная формула'
      const formula__value_translete = value.formula_value?.split(' ').map(x => NamesTranslation[x] || x).join(' ') || 'Неизвестная формула'
      const formula_splited = value.formula_value?.split(' ') || []

      acc = [...acc, {
        ...value,
        formula_translete,
        formula__value_translete,
        formula_splited
      }]
      return acc
    }, [])
  }
}
const actions = {
  async fetchFormuls ({ commit }, data) {
    const regionParkId = data.regionParkId

    try {
      commit('START_LOADING')
      const response = await Api.parkManager.formuls.getFormulas({ regionParkId })
      if (data.tabId === 'pane-config.weekend') {
        commit('SET', response.weekend)
      } else {
        commit('SET', response.workDay)
      }
      commit('STOP_LOADING')
      Promise.resolve(response)
    } catch (e) {
      commit('STOP_LOADING')
      return Promise.reject(e)
    }
  },
  async updateFormula ({ commit, state }, { data, regionParkId, weekend }) {
    try {
      const response = await Api.parkManager.formuls.updateFormulas({ ...data, regionParkId, weekend })
      commit('UPDATE_FORMULS', {
        data,
        response
      })
      Message({
        message: 'Информация была изменена',
        type: 'success',
        duration: 5 * 1000
      })
    } catch (error) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
    }
  },
  async formulaCheck ({ commit }, { data, region_park_id }) {
    try {
      const response = await Api.parkManager.formuls.getConfiguratorInspector({ ...data, region_park_id })
      commit('SET_FORMULA_CHECK_RETURN', response)
      Message({
        message: 'Информация была получена!',
        type: 'success',
        duration: 5 * 1000
      })
      return response
    } catch (error) {
      Message({
        message: 'Ошибка',
        type: 'error',
        duration: 5 * 1000
      })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
